<template>
	<div class="balance-section">
		<span class="balance-category">{{ $t('navigation.wallet.balance') }}</span>

		<span v-if="balanceLoading" class="spinner-circle spinner-circle--balance"></span>
		<Currency v-else-if="emailVerified" class="balance-amount" :value="balance" :code="currency" />
		<span v-else class="balance-amount">-</span>
	</div>
</template>

<script>
import Currency from '@/components/currency';
import { mapState } from 'vuex';

export default {
	name: 'BalanceSection',
	components: {
		Currency,
	},
	computed: {
		...mapState(['emailVerified', 'balance', 'currency', 'balanceLoading']),
	},
};
</script>

<style lang="less" scoped>
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';
.balance-section {
	font-size: 13px;
	line-height: 1;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	.balance-category {
		color: rgba(255, 255, 255, 0.4);
		margin-right: auto;
		padding-right: 10px;
	}
	.balance-amount {
		color: #eda03b;
		font-weight: bold;
	}
}
.spinner-circle {
	&--balance {
		width: 20px;
		height: 20px;
		margin-bottom: -4px;
		&--balance {
			margin-left: auto;
		}
	}
}
</style>
